// extracted by mini-css-extract-plugin
export default {"tableCell":"Comments_tableCell__zQvXP","tableRoot":"Comments_tableRoot__qQfQq"};